export var FormErrorType = /*#__PURE__*/ function(FormErrorType) {
    FormErrorType["requiredWithLabel"] = "requiredWithLabel";
    return FormErrorType;
}({});
export var ColumnStateNames = /*#__PURE__*/ function(ColumnStateNames) {
    ColumnStateNames["Closed"] = "closed";
    ColumnStateNames["Opened"] = "opened";
    return ColumnStateNames;
}({});
